var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftRightBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 834,
    height: 612,
    viewBox: "0 0 935 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1806 469.196C-10.3967 389.98 -14.678 284.428 28.5782 199.809C65.7785 126.961 148.564 71.3662 244.172 38.2907C355.107 -0.090679 487.316 -11.5155 606.437 12.7123C637.736 19.0793 668.238 24.9227 697.763 35.3966C818.791 78.312 795.366 184.071 837.891 220.867C873.627 251.821 941.927 242.697 985.006 266.415C1101.11 330.458 1033.9 495.408 909.274 554.613C764.178 623.548 207.149 665.347 52.1806 469.196Z",
    fill: "#2364AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M52.1806 469.196C-10.3967 389.98 -14.678 284.428 28.5782 199.809C65.7785 126.961 148.564 71.3662 244.172 38.2907C355.107 -0.090679 487.316 -11.5155 606.437 12.7123C637.736 19.0793 668.238 24.9227 697.763 35.3966C818.791 78.312 795.366 184.071 837.891 220.867C873.627 251.821 941.927 242.697 985.006 266.415C1101.11 330.458 1033.9 495.408 909.274 554.613C764.178 623.548 207.149 665.347 52.1806 469.196Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftRightBackground);
export default __webpack_public_path__ + "static/media/gift_rightBackground.b9f5f66d626416650d5538f875fd29c6.svg";
export { ForwardRef as ReactComponent };